import { useGlobal } from "../context/ContenedorGlobal";
import { obtenerModulosDesdePermisos } from "../data/permisosUtils";
import "../styles/SelectorDeModulos.css";

function SelectorDeModulos({ setAbierto }) {

    const { permisos, moduloActual, setModuloActual, setSubModuloActual } = useGlobal();

    // Obtener módulos reales desde permisos
    let modulos = obtenerModulosDesdePermisos(permisos) // Del archivo permisosUtil.php 
        .filter(m => m !== "Autenticación");

    return (

        <div className="selector-modulos-sidebar">

            {modulos.map(modulo => (

                <div
                    key={modulo}
                    className={`modulo-tag ${moduloActual === modulo ? "activo" : ""}`}
                    onClick={() => {
                        setModuloActual(modulo);
                        setSubModuloActual(null);
                        setAbierto(false); // Cerrar el sidebar al cambiar de módulo para moviles
                    }}
                >
                    {modulo}
                </div>
            ))}
        </div>
    );
}

export default SelectorDeModulos;